import { gql } from "@apollo/client";

export const GET_PROJECT_OUTCOME = gql`
  query GetProjectOutcome {
    home_page_project_outcome {
      id
      img
      title
      link
      content
      home_page_project_id
    }
  }
`;

export const INSERT_PROJECT_OUTCOME = gql`
  mutation InsertProjectOutcome(
    $object: home_page_project_outcome_insert_input!
  ) {
    insert_home_page_project_outcome_one(object: $object) {
      id
      img
      title
      link
      content
      home_page_project_id
    }
  }
`;

export const DELETE_PROJECT_OUTCOME = gql`
  mutation DeleteProjectOutcome($id: uuid!) {
    delete_home_page_project_outcome_by_pk(id: $id) {
      id
    }
  }
`;
